import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import wrapReact from '../../util/react';
import { wrapFunc } from '../../util/js';
import { FETCH_CONTINIOUS_INTERVAL } from '../../config';
import { actGetUser, actUpdateUser } from '../../redux/action/user';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    getUser = wrapFunc((value, cb, intervalID) => {
      const { auth, intl, dispatch } = this.props;
      clearInterval(intervalID);
      actGetUser(dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          email: auth.email,
        },
        cb);
      return setInterval(
        actGetUser.bind(
          this, dispatch,
          {
            token: auth.token,
            lang: intl.locale,
            email: auth.email,
          },
          cb,
        ),
        FETCH_CONTINIOUS_INTERVAL,
      );
    }, 'getUser');

    updateUser = wrapFunc((data, cb) => {
      const {
        user, auth, dispatch,
      } = this.props;
      const callback = (res) => {
        actGetUser(dispatch, {
          email: user.email,
          token: auth.token,
        });
        if (cb) cb(res);
      };

      actUpdateUser(dispatch,
        {
          email: user.email,
          token: auth.token,
          password: data.password,
          current_password: data.current_password,
        },
        callback);
    }, 'changePwd');

    render() {
      const { ui, auth, user } = this.props;
      return (
        <Comp
          {...this.props}
          ui={ui}
          auth={auth}
          user={user}
          getUser={this.getUser}
          onSubmit={this.updateUser}
        />
      );
    }
  }
  wrapComp.propTypes = {
    ui: PropTypes.object.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string.isRequired,
    }).isRequired,
    auth: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };
  function mapStateToProps(state) {
    return {
      user: state.get('user'),
      auth: state.get('auth'),
      ui: state.get('ui').uiHome,
    };
  }
  return connect(mapStateToProps)(wrapReact(wrapComp, name));
}
